import { CustomersActions } from "../../types";

const initialState: any = { loading: false, data: [] };

export default function (state: any = initialState, action: any) {
  switch (action.type) {
    case CustomersActions.StoreInitialState:
      return {
        ...state,
        data: action.payload.items.map((item: any) => ({
          ...item,
          price: (Math.floor(item.price * 100) / 100).toFixed(2),
        })),
      };

    default:
      return state;
  }
}
